// extracted by mini-css-extract-plugin
export default {"modalContainer":"LoginMethodModal_modalContainer__79dPt","mobile":"LoginMethodModal_mobile__+juRA"};